import { datadogRum } from '@datadog/browser-rum';

const initializeDatadogRum = () => {
    if (process.env.NEXT_PUBLIC_DATADOG_RUM_ENABLED) {
        datadogRum.init({
            applicationId: '53722fb4-9215-4c6a-921c-91accfe8ecb8',
            clientToken: 'pubbd2f823a9171abbc32daabe2b4460b09',
            site: 'datadoghq.com',
            service: 'design-services',
            env: 'prod',
            // Specify a version number to identify the deployed version of your application in Datadog
            version: '1.0.0',
            sampleRate: 3,
            // track 100% of sessions as Browser RUM
            replaySampleRate: 0,
            trackInteractions: true,
            defaultPrivacyLevel: 'mask-user-input',
        });
        datadogRum.startSessionReplayRecording();
    }
};

export default initializeDatadogRum;
